import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  mounted () {
    if (this.chartData) {
    // this.chartData is created in the mixin
    this.renderChart(this.chartData, {
        scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        scaleFontColor: '#999',
        scaleFontStyle: '600',
        tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        tooltipCornerRadius: 3,
        maintainAspectRatio: true,
        responsive: true,
        maxHeight: '50',
        legend: {
            display: false
         },

      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/PieChart.js